import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { typography } from '../constants/styles';

const StyledAppContainer = styled.div`
  font-family: ${typography.museoSans};
  font-weight: 300;
`;

class AppContainer extends Component {
  state = { val: null };

  render() {
    const { children } = this.props;
    return (
      <StyledAppContainer>
        {children}
      </StyledAppContainer>
    );
  }
}

AppContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
};

AppContainer.defaultProps = {
  // ---
};

const mapStateToProps = state => ({
  value: state.value,
});

const dispatchToProps = dispatch => bindActionCreators({
  // ..
}, dispatch);

export default connect(mapStateToProps, dispatchToProps)(AppContainer);
